/**
 * Domain-agnostic configuration for the reusable <MappingImportDialog>.
 *
 * Each entry tells the shared dialog how ONE domain feeds the mapping-import
 * flow, so the dialog itself contains no domain names or per-domain branches:
 *
 *   routeName        list-page route name; used to reload the list
 *                    (dispatch 'fetch' + routeName) after a finished import.
 *   uploadDir        domain endpoint, used BOTH as the api.putFile directory
 *                    for the (preflight) upload and as the target of the
 *                    commit/abandon POST (?action=mappingImportProcess).
 *   mappingGetter    vuex getter holding the currently selected mapping alvId.
 *   tagsGetter       vuex getter holding the free-text import tag (optional).
 *   extraParams      (getters) => ({ ... }) domain-specific params merged into
 *                    BOTH the preflight upload and the commit trigger
 *                    (e.g. { searchWorkTitle: 'yes' }). Read once, when the
 *                    preflight starts, and replayed verbatim on commit - the BE
 *                    does not carry them over and does not check that they
 *                    match, so a differing commit would silently import
 *                    something other than what the summary showed.
 *   supportsPreflight  true  -> upload runs a dry-run and waits for confirmation
 *                              (preflight -> summary -> commit/abandon).
 *                      false -> legacy single-shot import (upload -> poll ->
 *                              finished); lets domains migrate one at a time.
 *   contextHelp      context key for the in-dialog ContextHelpIcon (optional).
 *   resetMutations   { mutationName: resetValue } committed when the dialog
 *                    closes, to clear the domain's import inputs (optional).
 *
 * Adding a new domain to the preflight flow:
 *   1) add an entry here,
 *   2) render <MappingImportDialog :domainConfig="..."> behind the same
 *      v-if (selected import === 'mappingImport') split on that domain's page.
 * No changes to the dialog's flow logic are required.
 */
export const mappingImportConfigs = {
    Works: {
        routeName: 'Works',
        uploadDir: 'publishing/works',
        mappingGetter: 'getWorksDetailsImportSelectedMapping',
        tagsGetter: 'getWorkImportTags',
        extraParams: (getters) => ({
            searchWorkTitle: getters.getWorksDetailsSearchWorkByTitleCheckbox ? 'yes' : 'no'
        }),
        supportsPreflight: true,
        contextHelp: 'PublishingWorksListpageImportMapping',
        resetMutations: {
            setWorkImportTags: null,
            setWorksDetailsSearchWorkByTitleCheckbox: false
        }
    }
}

export default mappingImportConfigs
